export default __webpack_public_path__ + "static/media/nucamp react native app-canvas.c0e02e8c.png";